"use client";

import { useCallback } from "react";

import {
  markFirstWorkCompleteDialogSeen,
  shouldShowFirstWorkCompleteDialog,
} from "./firstWorkCompleteDialog";

export function useFirstWorkCompleteDialog(workerId: string | undefined) {
  const markAsSeen = useCallback(() => {
    markFirstWorkCompleteDialogSeen(workerId);
  }, [workerId]);

  const shouldShowDialog = useCallback(
    (isFirstWorkCompleted: boolean) =>
      shouldShowFirstWorkCompleteDialog({
        isFirstWorkCompleted,
        workerId,
      }),
    [workerId],
  );

  return {
    shouldShowDialog,
    markAsSeen,
  };
}
